export default __webpack_public_path__ + "static/media/1ec6cb0dcc3e019fd8e9ae71f69fc7d1.cdf97414.png";